import { auth } from "lib/firebase"

/**
 * Get the current user's ID if authenticated
 * @returns {string|null} User ID or null if not authenticated
 */
export const getCurrentUserId = () => {
  const user = auth.currentUser
  return user ? user.uid : null
}

/**
 * Get the current user object if authenticated
 * @returns {Object|null} User object or null if not authenticated
 */
export const getCurrentUser = () => {
  return auth.currentUser
}

/**
 * Check if user is currently authenticated
 * @returns {boolean} True if user is authenticated, false otherwise
 */
export const isUserAuthenticated = () => {
  return auth.currentUser !== null
}

/**
 * Get user display name or email as fallback
 * @returns {string|null} Display name, email, or null if not authenticated
 */
export const getUserDisplayName = () => {
  const user = auth.currentUser
  if (!user) return null
  return user.displayName || user.email || "Anonymous User"
}

/**
 * Get user email
 * @returns {string|null} User email or null if not authenticated
 */
export const getUserEmail = () => {
  const user = auth.currentUser
  return user ? user.email : null
}
